import React from "react";
import type { StyleProp, ViewStyle, ViewProps, ImageStyle } from "react-native";
import { LongPressGestureHandler } from "react-native-gesture-handler";
import type { AnimateProps } from "react-native-reanimated";
import Animated from "react-native-reanimated";

import Constants from "expo-constants";

import { SBImageItem } from "./SBImageItem";
import { SBTextItem } from "./SBTextItem";

interface Props extends AnimateProps<ViewProps> {
  style?: StyleProp<ViewStyle>
  index?: number
  pretty?: boolean,
  item?: string | Object,
  imageStyle?: StyleProp<ImageStyle>,
  removeSampleMark?: boolean,
  withShadow?: boolean,
}

export const SBItem: React.FC<Props> = (props) => {
  const { style, index, pretty, item, testID, imageStyle, removeSampleMark, ...animatedViewProps } = props;
  const enablePretty = Constants?.expoConfig?.extra?.enablePretty || false;
  const [isPretty, setIsPretty] = React.useState(pretty || enablePretty);

  // console.log(item, 'image');

  return (
    <LongPressGestureHandler
      onActivated={() => {
        setIsPretty(!isPretty);
      }}
    >
      <Animated.View testID={testID} style={{ flex: 1, maxWidth: 'auto' }} {...animatedViewProps}>
        <SBImageItem style={[style, { flex: 1 }]} imageStyle={imageStyle} index={index} item={item} />
      </Animated.View>
    </LongPressGestureHandler>
  );
};